import { Link } from "react-router-dom"

import useCollection from "areas/collection/hoc/use-collection"
import { cn } from "styles/utils"

const Breadcrumb = () => {
  const { data } = useCollection()
  const breadcrumbs = data?.breadcrumb || []

  return (
    <nav aria-label="Breadcrumb">
      <ol className="text-14 text-grey-500 leading-16 m-0 list-none p-0 font-medium">
        {breadcrumbs.map((breadcrumb, idx) => (
          <li
            className={cn(
              "inline",
              idx > 0 && "before:px-4 before:content-['/']"
            )}
            key={`breadcrumb_${breadcrumb.name}`}
          >
            {breadcrumb.url ? (
              <Link data-lc="breadcrumb" to={breadcrumb.url}>
                {breadcrumb.name}
              </Link>
            ) : (
              <>{breadcrumb.name}</>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumb
